import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { FilteringListBox } from '../../common/react/components/FilteringListBox';
import { SparseCachedList } from '../../common/react/SparseCachedList';
import { IDataAlertInfo } from '../../ts/models/IDataAlertInfo';
import { DataAlertUsers } from '../resources/DataAlertUsers';
import { IUser } from '../../ts/ServerApi/types/IUser';
import { ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import {
  getSessionManagementServiceInstance,
  SessionManagementService,
} from '../../sessionManagement/SessionManagementService';
import { DialogPositioningBehavior, DialogType, TabStyles } from '@tableau/widgets';
import { ManageDataAlertRecipientsDialogStyles } from '../styles/ManageDataAlertRecipientsDialogStyles';

export class ManageDataAlertRecipientsDialog {

  public static readonly instance = new ManageDataAlertRecipientsDialog();

  // Search string filter for filtering recipients in the list box
  private filter: string;

  // Cached list of items fetched from the user query provided to the component
  private itemCache: SparseCachedList<FilteringListBox.Item<IUser>, IUser>;

  // Item store for the FilteredListBox component (fetches items from the item cache)
  private itemStore = { getItems: this.getItems.bind(this) };

  private  dataAlert: IDataAlertInfo;

  private sessionManagementService: SessionManagementService;

  public open(alert: IDataAlertInfo) {
    this.dataAlert = alert;
    this.createCacheWithFilter('');

    const props:  FilteringListBox.Props<IUser> = {
      searchBoxPlaceholder: Messages.searchRecipients(),
      matchPrefixesOnly: false,
      itemStore: this.itemStore,
      style: ManageDataAlertRecipientsDialogStyles.STYLE,
      listBoxStyle: ManageDataAlertRecipientsDialogStyles.LIST_BOX_STYLE,
    };

    const modal = ReactModalService.open({
        title: Messages.column_recipients(),
        type: DialogType.LightweightTitleBar,
        positioningBehavior: DialogPositioningBehavior.Centered,
        dialogContent: <FilteringListBox {...props}/>,
        dialogContentStyle: {
            paddingTop: TabStyles.Spacing.LargeSpace,
            paddingBottom: TabStyles.Spacing.SmallSpace
        },
        showCloseButton: true,
        dialogWidth: 460
    });
    return modal;
  }

  private getItems(filter: string, start: number, end: number): Promise<FilteringListBox.Item<IUser>[]> {
    if (filter !== this.filter) {
      this.createCacheWithFilter(filter);
    }

    return this.itemCache.getItems(start, end);
  }

  private createCacheWithFilter(filter: string) {
    if(!this.sessionManagementService){
      this.sessionManagementService = getSessionManagementServiceInstance();
    }

    const query = DataAlertUsers.getUsersQuery(this.dataAlert.id, filter);
    this.filter = filter;
    this.itemCache = new SparseCachedList<FilteringListBox.Item<IUser>, IUser>(query, (user: IUser) => {
      const siteUrls = new SiteUrls({siteUrlName: this.sessionManagementService.sessionSiteUrlName(), queryString: window.location.search});
      return {
        label: user.displayName,
        url: siteUrls.userUrl(user.username, user.domainName),
        rawItem: user,
      };
    });
  }
}
